import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit {

  public script!: HTMLScriptElement;

  
  protected showMenu: boolean = false;
  ngOnInit() {
    
  }

}
